<div class="flex flex-row flex-wrap justify-between items-center flex-1-0-100" (mouseover)="isMouseOver=true"
     (mouseout)="isMouseOver=false"
     [ngClass]="{'active': isActive, 'inactive': isInActive}">
  <ng-template particleCellDecoratorHost></ng-template>
</div>
